import * as React from "react";
import { FolderOpen } from "lucide-react";

import { VideoProjectDetail } from "@/interfaces";
import { VideosSection } from "@/components/Forms/VideoProjectDetail/components/VideosSection";

interface Props {
  videoProject: VideoProjectDetail;
}

export const EditorProjectFiles: React.FC<Props> = ({ videoProject }) => {
  return (
    <>
      <div className="flex flex-col gap-3">
        <div className="flex flex-row justify-between items-center w-full select-none">
          <label className="sectionHeader font-semibold text-slate-800 text-sm flex items-center gap-1.5">
            <FolderOpen className="size-4.5 text-blue-600" />
            Original Files
          </label>
        </div>
        <div className="videoProjectContainer flex flex-col gap-4 bg-slate-50/50 p-5 rounded-xl border border-slate-200 w-full">
          {videoProject.originalMedia && (
            <VideosSection
              type="ORIGINAL"
              videos={videoProject.originalMedia?.media!!}
              videoProjectId={videoProject.videoProjectId!!}
              isEditor={true}
            />
          )}
        </div>
      </div>
    </>
  );
};
